/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DialogBannerComponent } from '@src/app/shared/dialogs/dialog-banner-component';

export interface ImageViewDialogData {
    imageUrl: string;
    fileName: string;
}

@Component({
    selector: 'app-image-view-dialog',
    template: `
        <app-dialog-banner [text]="data.fileName" [dialogRef]="dialogRef">
            <a [href]="data.imageUrl" [download]="data.fileName" class="banner-icon"
                i18n-matTooltip matTooltip="Click to download the image" data-image-download>
                <mat-icon>download</mat-icon>
            </a>
            <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
            <span class="banner-icon" (click)="toggleMaximized()" [matTooltip]="maximized ? restoreTip : maximizeTip">
                <mat-icon>{{ maximized ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
            </span>
        </app-dialog-banner>
        <div class="image-holder" [attr.data-form-ready]="'true'">
            <img [src]="data.imageUrl" [alt]="data.fileName"
                [style.max-height]="maximized ? 'calc(100vh - 48px)' : '80vh'">
        </div>
    `,
    styles: [`
        .banner-icon { color: white; cursor: pointer; padding-right: 8px; display: flex; }
        .image-holder { display: flex; justify-content: center; align-items: center; overflow: auto; }
        img { max-width: 100%; object-fit: contain; }
    `],
    imports: [DialogBannerComponent, MatIconModule, MatTooltipModule]
})
export class ImageViewDialogComponent {
    data = inject<ImageViewDialogData>(MAT_DIALOG_DATA);
    dialogRef = inject(MatDialogRef<ImageViewDialogComponent>);

    maximized = false;
    maximizeTip = $localize`Click to maximise`;
    restoreTip = $localize`Click to restore the original size`;

    toggleMaximized() {
        this.maximized = !this.maximized;
        if (this.maximized) {
            this.dialogRef.updateSize('100vw', '100vh');
        } else {
            this.dialogRef.updateSize('', '');
        }
    }
}
